module.exports = __webpack_public_path__ + "img/blog-17.e25e1ba4.webp";